import React, { useEffect, useState } from "react";
import axios from "../api/axiosInstance";
import Swal from "sweetalert2";

export default function PrescriptionHistoryPage() {
  const [items, setItems] = useState([]);
  const [previewImage, setPreviewImage] = useState(null);

  useEffect(() => {
    axios.get("/availability/history/")
      .then(res => setItems(res.data))
      .catch(() => {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: "Unable to load prescription history"
        });
      });
  }, []);

  return (
    <div style={{ padding: 20 }}>
      <h2>Prescription History</h2>

      {items.length === 0 && <p>No prescriptions yet</p>}

      {items.map(rx => (
        <div key={rx.id} style={{
          border: "1px solid #ddd",
          padding: 15,
          borderRadius: 8,
          marginBottom: 12,
          background: "#fff"
        }}>
          <p><b>ID:</b> {rx.id}</p>
          <p><b>Status:</b> {rx.status}</p>
          <p>
            <b>Uploaded:</b>{" "}
            {rx.uploaded_at
              ? new Date(rx.uploaded_at).toLocaleString()
              : "N/A"}
          </p>

          <p><b>Files:</b></p>

          {rx.files && rx.files.length > 0 ? (
            rx.files.map((file, i) => {
              if (!file) return null;

              const optimized = file.includes("/upload/")
                ? file.replace("/upload/", "/upload/w_600/")
                : file;

              const isPDF =
                file.toLowerCase().includes(".pdf") ||
                file.includes("/raw/upload/");

              return (
                <div key={`${rx.id}-${i}`} style={{ marginTop: 10 }}>

                  {isPDF ? (
                    <button
                      onClick={() => window.open(file, "_blank")}
                      style={{
                        padding: "6px 10px",
                        background: "#2563eb",
                        color: "#fff",
                        border: "none",
                        borderRadius: 6,
                        cursor: "pointer"
                      }}
                    >
                      📄 Open PDF
                    </button>
                  ) : (
                    <img
                      src={optimized}
                      alt="prescription"
                      onClick={() => setPreviewImage(file)}
                      style={{
                        width: "100%",
                        maxWidth: "250px",
                        maxHeight: "200px",
                        objectFit: "contain",
                        borderRadius: 8,
                        cursor: "pointer",
                        border: "1px solid #ddd"
                      }}
                    />
                  )}

                </div>
              );
            })
          ) : (
            <span>No file</span>
          )}
        </div>
      ))}

      {/* 🔥 FULLSCREEN IMAGE PREVIEW (OUTSIDE MAP) */}
      {previewImage && (
        <div
          onClick={() => setPreviewImage(null)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.9)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 999
          }}
        >
          <img
            src={previewImage}
            alt="preview"
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              borderRadius: 10
            }}
          />

          {/* CLOSE BUTTON */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              setPreviewImage(null);
            }}
            style={{
              position: "absolute",
              top: 20,
              right: 20,
              background: "red",
              color: "#fff",
              border: "none",
              padding: "6px 10px",
              borderRadius: 6,
              cursor: "pointer"
            }}
          >
            ✖
          </button>
        </div>
      )}

    </div>
  );
}